export const editorConstants = {
    lineHeight: 19,
    symbolWidth: 8.31578947,
};
